export class InvalidUpdateHandlerError extends Error { }
;
